// import { ResCurrentUser } from '../type/user';
import { getQueryVariable, deleteSearch } from "../utils/http";
import { verify, logOut } from "../api/login";
import { loginUrl } from "../api/fetch";
import { Modal } from "antd";

// export interface IUserInfoState {
//   isLoginStatus: boolean;
//   userInfo?: ResCurrentUser;
// }

export interface LoginTools {
  setLoginStatus: (status: boolean) => void;
  getUserInfo: () => Promise<object | undefined>;
  toLoginOut: () => void;
}

/**
 * 登录并获取用户信息hooks
 * @function
 * @params {IUserInfoState} userState 用户信息
 * @returns store extend LoginTools
 */
export const useLoginProvide = () => {
  //   const common = commonStore();
  // 登录并获取用户信息
  const getUserInfo = async () => {
    // 获取集团登录传递的token
    const token = getQueryVariable("token");
    // let LocalToken = JSON.parse(localStorage.getItem("intelli_token")!);
    const res = await verify(token);
    // 第二次进入系统   发现调通了
    deleteSearch();
    if (res.code !== 0) {
      Modal.info({
        title: "温馨提示",
        content: res.msg + "失败",
        onOk: () => {
          toLoginOut();
        },
      });
      return null;
    } else {
      return res.data;
    }
  };

  // 设置登录状态
  //   const setLoginStatus = (status: boolean) => {
  //     common.hasLogin = status;
  //   };

  // 退出登录
  const toLoginOut = async () => {
    // 调用后端退出登录接口
    const res = await logOut();

    localStorage.removeItem("intelli_userInfo");
    // localStorage.removeItem('intelli_token');
    // 重定向到集团登录页面
    window.location.href =
      "https://sso.saash.vdyoo.com/sso/logout?path=" + loginUrl;
  };

  return {
    // setLoginStatus,
    toLoginOut,
    getUserInfo,
  };
};
